import { lazy } from "react";
import { RouteObject, Navigate, useParams } from "react-router-dom";
import { communesData } from "../mocks/communes";

const HomePage = lazy(() => import("../pages/home/page"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const MentionsLegalesPage = lazy(() => import("../pages/mentions-legales/page"));
const CommunePage = lazy(() => import("../pages/commune/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

// Wrapper pour valider la commune
const CommuneWrapper = () => {
  const { commune } = useParams<{ commune: string }>();
  
  // Liste des routes statiques à exclure
  const staticRoutes = ['services', 'mentions-legales'];
  
  // Si c'est une route statique, rediriger vers 404
  if (commune && staticRoutes.includes(commune)) {
    return <Navigate to="/404" replace />;
  }
  
  // Si la commune n'existe pas dans les données, rediriger vers 404
  if (!commune || !communesData[commune]) {
    return <Navigate to="/404" replace />;
  }
  
  return <CommunePage />;
};

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegalesPage />,
  },
  {
    path: "/404",
    element: <NotFoundPage />,
  },
  {
    path: "/:commune",
    element: <CommuneWrapper />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;
